module.exports = __webpack_public_path__ + "static/media/Logo__Google_white.498db4b5.svg";